import { Component, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogService } from 'primeng/dynamicdialog';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { OrderDetailComponent } from '../../clinical-care/views/order/order-detail/order-detail.component';
import { TomoDashboardOrder } from '../services/api/dashboard.service';

/**
 * Dashboard de Informes Médicos: órdenes emitidas HOY con al menos un estudio TOMO,
 * de todas las sucursales juntas.
 */
@Component({
    selector: 'app-tomo-orders-today',
    standalone: true,
    imports: [TableModule, TagModule, ButtonModule, TooltipModule],
    templateUrl: './tomo-orders-today.component.html',
    providers: [DialogService]
})
export class TomoOrdersTodayComponent {
    @Input() orders: TomoDashboardOrder[] = [];
    @Input() loading = false;

    constructor(private dialogService: DialogService) {}

    statusLabel(code: string): string {
        switch (code) {
            case 'PENDING':
                return 'Pendiente';
            case 'IN_PROGRESS':
                return 'En proceso';
            case 'INCOMPLETE':
                return 'Incompleto';
            case 'COMPLETED':
                return 'Completado';
            case 'CANCEL':
                return 'Cancelado';
            default:
                return code;
        }
    }

    statusSeverity(code: string): 'success' | 'info' | 'warn' | 'danger' | 'secondary' {
        switch (code) {
            case 'PENDING':
                return 'danger';
            case 'IN_PROGRESS':
            case 'INCOMPLETE':
                return 'warn';
            case 'COMPLETED':
                return 'success';
            case 'CANCEL':
                return 'secondary';
            default:
                return 'info';
        }
    }

    openOrderDetail(order: TomoDashboardOrder): void {
        this.dialogService.open(OrderDetailComponent, {
            header: `Detalle de Orden: ${order.codOrder}`,
            width: '60vw',
            height: 'auto',
            contentStyle: { overflow: 'auto' },
            baseZIndex: 10000,
            maximizable: false,
            closable: true,
            data: { idOrder: order.idOrder }
        });
    }
}
